import { __assign } from "tslib";
import cloneDeep from 'lodash/cloneDeep';
var _convertObjectUndefinedNull = function (obj) {
    if (obj === undefined) {
        return null;
    }
    if (obj !== null && typeof obj === 'object') {
        if (obj instanceof Map) {
            obj.forEach(function (value, key) { return obj.set(key, _convertObjectUndefinedNull(value)); });
        }
        else {
            var newObj_1 = __assign({}, obj);
            Object.keys(newObj_1).forEach(function (key) {
                newObj_1[key] = _convertObjectUndefinedNull(newObj_1[key]);
            });
            return newObj_1;
        }
    }
    return obj;
};
var convertObjectUndefinedNull = function (obj) {
    return _convertObjectUndefinedNull(cloneDeep(obj));
};
export default convertObjectUndefinedNull;
//# sourceMappingURL=convert-object-undefined-null.js.map